<template>
  <v-row>
    <v-col>
      <v-file-input
          v-model="file"
          show-size
          chips
          :label="label"
          ref="fileinput"
      >
      </v-file-input>
    </v-col>
    <v-col>
      <div class="v-input v-text-field">
        <v-chip
            v-if="modelValue"
            close
            label
            color="primary"
            @click:close="remove"
        >
          {{ modelValue ? modelValue.name : '' }}
        </v-chip>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "FileField",

  props: {
    label: String,
    modelValue: Object,
  },

  model: {
    prop: 'modelValue',
    event: 'change'
  },

  data: () => ({
    file: null,
  }),

  watch: {
    file(value) {
      if (value) {
        this.$emit('change', {
          uploadFile: value,
          name: value.name,
          file: null,
        });
      }
    },
    modelValue() {
      this.$refs.fileinput.reset();
    },
  },

  methods: {
    remove() {
      this.$emit('change', null);
    },
  },

}
</script>
<style scoped>
.col {
  padding-top: 0;
  padding-bottom: 0;
}
.row {
  margin-top: 0 !important;
}
</style>